var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"error_page"},[_c('div',{staticClass:"error_code"},[_c('span',[_vm._v("4")]),_c('span',[_vm._v("0")]),_c('span',[_vm._v("4")])]),_c('div',{staticClass:"error_msg"},[_c('div',[_vm._v("NOT")]),_c('div',[_vm._v("FOUND")])])])])
}]

export { render, staticRenderFns }